import { API } from 'aws-amplify'
import {
  ReservedShowing,
  Showing,
  ReserveData,
  FormShowing
} from '../types/showings'

const createShowings = async (
  userId: string,
  apartmentId: string,
  showings: FormShowing[]
) => {
  const newShowings: Showing[] = await API.post(
    'showings',
    `/users/${userId}/apartments/${apartmentId}/showings`,
    {
      body: showings
    }
  )
  return newShowings
}

const setShowingApplicants = async (
  apartmentId: string,
  showingId: string,
  applicationIds: string[],
  confirmImmediately?: boolean
) => {
  const newApplicants: string[] = await API.post(
    'showings',
    `/apartments/${apartmentId}/showings/${showingId}/applications?confirmImmediately=${confirmImmediately ? 'true' : 'false'
    }`,
    {
      body: applicationIds
    }
  )
  return newApplicants
}

const getShowings = async (userId: string, apartmentId: string) => {
  const showings: Showing[] = await API.get(
    'showings',
    `/users/${userId}/apartments/${apartmentId}/showings`,
    {}
  )

  return showings
}

const getUserShowings = async () => {
  const showings: Showing[] = await API.get('showings', `/showings`, {})
  return showings
}

const getShowingsByApartmentIdArray = async (apartmentIdArray: string[]) => {
  const showings: Showing[] = await API.post(
    'showings',
    `/byApartmentIdArray`,
    {
      body: { apartmentIdArray: apartmentIdArray }
    }
  )
  return showings
}

const getShowingsByCode = async (code: string) => {
  const dataForReserve: ReserveData = await API.get(
    'showings',
    `/showings/${code}`,
    {}
  )
  return dataForReserve
}

const reserveShowing = async (
  code: string,
  reserveBody: { showingId: string }
) => {
  const reserved: ReservedShowing[] = await API.post(
    'showings',
    `/showings/${code}`,
    {
      body: reserveBody
    }
  )
  return reserved
}

export interface DeleteShowingArgs {
  userId: string
  apartmentId: string
  showingId: string
}

const deleteShowing = async ({
  userId,
  apartmentId,
  showingId
}: DeleteShowingArgs) => {
  const showing = await API.del(
    'showings',
    `/users/${userId}/apartments/${apartmentId}/showing/${showingId}`,
    {}
  )
  return showing
}

interface CancelShowingProps {
  applicationCode: string
  showingIds: string[]
}

const cancelShowing = async ({
  applicationCode,
  showingIds
}: CancelShowingProps) => {
  return await API.post('showings', `/showings/${applicationCode}/cancel`, {
    body: { showingIds }
  })
}

const getForRentapp = async (code: string) => {
  const data: any = await API.get(
    'showings',
    `/showings/rentapp/${code}`,
    {}
  )
  return data
}

export default {
  createShowings,
  setShowingApplicants,
  getShowings,
  getUserShowings,
  getShowingsByCode,
  reserveShowing,
  deleteShowing,
  cancelShowing,
  getShowingsByApartmentIdArray,
  getForRentapp,
}
